import NewsletterUnsubscribePage from "pages/NewsletterUnsubscribePage";
import React from "react";

const NewsletterUnsubscribeRoute = () => <NewsletterUnsubscribePage />;

export default NewsletterUnsubscribeRoute;
